<template>
  <div class="campaign-container">
    <div class="campaign-card">
      <h4 class="campaign-title editorial">Thank you</h4>
      <div class="flex justify-center">
        <img src="../../assets/gift-icon-3.svg" />
      </div>
      <p class="campaign-subtitle">
        Your form has been submitted.
      </p>
      <p class="campaign-subtitle info">
        For the best merch and customizations, try
        <a
          href="https://www.gemnote.com/"
          rel="noopener noreferrer"
          target="_blank"
          >Gemnote.</a
        >
      </p>
    </div>
  </div>
</template>

<script>
import { layouts } from '../../helpers'

export default {
  name: 'AddressCollectionConfirm',
  props: ['uuid'],
  created() {
    this.$store.dispatch('layout/setPageLayout', layouts.ADDRESS_COLLECTION)
  }
}
</script>

<style lang="scss" scoped>
@import '@/global.scss';

.disabled {
  opacity: 0.9;
  pointer-events: none;
}

.campaign-container {
  height: auto;
  margin: 0 auto;
  padding-top: 3rem;
}

.campaign-card {
  padding-top: 1rem;
  margin: 0 auto;
}

.campaign-icon {
  width: 50px;
}

.campaign-title {
  font-size: 2.5rem;
  padding: 1.25rem 0;
  font-weight: 400;
  margin-bottom: 2rem;
}

.campaign-subtitle {
  font-size: 0.938rem;
  text-align: center;
  margin: 2rem 0;

  &.info {
    font-size: 0.75rem;

    a {
      font-weight: bold;
      text-decoration: none;
    }
  }
}

.row {
  display: grid;
  grid-template-columns: 25% 25% 25% 25%;
  grid-template-rows: auto;
  margin-bottom: 2rem;
  padding: 0.5rem;
}

.heading {
  grid-column-start: 2;
  grid-column-end: 3;
}

.content {
  grid-area: 'content';
}

.label {
  font-size: 14px;
  text-align: left;
}

.column-info {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;

  span {
    margin-bottom: 0.3rem;
    font-size: 14px;
    font-weight: normal;
    text-align: left;
  }
}

.footer-info {
  font-size: 0.875rem;
  padding-top: 16rem;

  a {
    font-weight: bold;
    text-decoration: none;
  }
}

@media screen and (max-width: 1100px) and (min-width: 900px) {
  .campaign-card {
    width: 60%;
  }
}

@media screen and (max-width: 899px) and (min-width: 700px) {
  .campaign-card {
    width: 70%;
  }

  .row {
    display: grid;
    grid-template-columns: 20% 30% 30% 20%;
  }
}

@media screen and (max-width: 699px) and (min-width: 500px) {
  .campaign-card {
    width: 85%;
  }

  .row {
    display: grid;
    grid-template-columns: 12% 38% 38% 12%;
  }
}

@media screen and (max-width: 499px) and (min-width: 320px) {
  .campaign-card {
    width: 90%;
    padding: 3rem 0;
  }

  .campaign-title {
    font-size: 1rem;
    margin-bottom: 1rem;
    padding: 0 1rem;
  }

  .campaign-subtitle {
    padding: 0 1rem;
    font-size: 12px;
    margin-bottom: 3rem;
  }

  .row {
    gap: 0.5rem;
    grid-template-columns: 10% 35% auto 0%;
  }

  .label {
    font-size: 11px;
  }

  .column-info {
    span {
      font-size: 11px;
    }
  }

  .footer-info {
    padding: 1rem;
    font-size: 12px;
  }
}
</style>
